// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js';
import Vue from 'vue';
import Buefy from 'buefy';

import App from './App';
import router from './router';

import { store } from './store/store';

import '@fortawesome/fontawesome-free/css/all.css';
import 'es6-promise/auto';

import 'leaflet/dist/leaflet.css';
import { LMap } from 'vue2-leaflet';

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

import Vue2TouchEvents from 'vue2-touch-events';
import { ToastMixin } from './mixins/toastMixin';

import i18n from './i18n';

import Vue2Filters from 'vue2-filters';

Vue.use(Vue2Filters);

Vue.use(Vue2TouchEvents, {
    disableClick: true
});

Vue.mixin(ToastMixin);

Vue.config.productionTip = false;

Vue.use(require('vue-moment'));

Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultLocale: 'en-GB' // TODO this is not working, why?
});

Vue.component('l-map', LMap);

Vue.use(PerfectScrollbar);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: (h) => {
        return h(App);
    }
});
